import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function LogoDesign() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bcd3c00a753a58001381db301fde7424938a220e-1381x548.jpg)` }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Logo Design</h1>
            <p style={{ marginBottom: '3.5rem' }}>Logo design is a collaborative process, whereby we seek to understand your vision and ideas, then convert them into a visual representation of your brand identity.</p>
            <h3>Custom Logo Design</h3>
            <p style={{ marginBottom: '3.5rem' }}>We create completely custom and remarkable logo designs that graphically communicate the core characteristics of your business and give a memorable foundation to your marketing campaigns.</p>
            <h3>Our logo design process includes:</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Design consultation</li>
              <li>4 - 5 initial design concepts</li>
              <li>3 rounds of revisions</li>
              <li>Final design rendered in full colour</li>
              <li>Logo provided in original artwork file format, as well as various file formats for applying your logo to various uses (.jpg, .png, .pdf)</li>
            </ul>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/b6f12d8bf04cfa9da54d7c82b54a30198e62f331-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default LogoDesign